export const SECTIONS = {
  LANDING: 'landing-section',
  WORK_EXPERIENCE: 'work-experience-section',
  PROJECT_EXPERIENCE: 'project-experience-section',
  PROFILE_DETAILS: 'profile-details-section',
};

export const SECTION_ORDER = [
  SECTIONS.LANDING,
  SECTIONS.WORK_EXPERIENCE,
  SECTIONS.PROJECT_EXPERIENCE,
  SECTIONS.PROFILE_DETAILS,
];

export const SECTION_COLOR_SCHEMES = {
  [SECTIONS.LANDING]: 'primary',
  [SECTIONS.WORK_EXPERIENCE]: 'secondary',
  [SECTIONS.PROJECT_EXPERIENCE]: 'light',
  [SECTIONS.PROFILE_DETAILS]: 'secondary',
};

export default {
  SECTIONS,
  SECTION_ORDER,
  SECTION_COLOR_SCHEMES,
};
